<template>
  <div class="websitesearch-container">
    <el-card class="box-card" shadow="always">
      <el-table
        :data="searchData"
        height="600"
        style="width: 100%"
        stripe>
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          prop="type"
          width="80">
          <template slot="header" slot-scope="scope">
            <el-button size="mini" type="primary" @click="getWebsiteListByTitle" icon="el-icon-search"></el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          min-width="300"
          show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="searchTitle"
              size="mini"
              placeholder="输入关键字搜索"
              @keyup.enter.native="getWebsiteListByTitle"/>
          </template>
          <template slot-scope="scope">
            <el-link type="primary" :href='scope.row.url' target="_blank">{{ scope.row.title }}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import {getWebsiteListByTitle} from '../api/website'
export default {
  name: 'websitesearch',
  data () {
    return {
      searchData: [],
      searchTitle: ''
    }
  },
  methods: {
    getWebsiteListByTitle () {
      getWebsiteListByTitle(this.searchTitle).then(response => {
        this.searchData = response.data
      })
    }
  }
}
</script>

<style scoped>
.websitesearch-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.box-card {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/websitesearch.vue